import { Page, View, Text, StyleSheet, Image, Font } from "@react-pdf/renderer";

Font.register({
  family: "Roboto",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/roboto/files/roboto-latin-400-normal.woff",
      fontWeight: "normal",
    },
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/roboto/files/roboto-latin-700-normal.woff",
      fontWeight: "bold",
    },
  ],
});

Font.registerHyphenationCallback(word => [word]);
const styles = StyleSheet.create({
  text: {
    fontFamily: "Roboto",
  },
  boldText: {
    fontFamily: "Roboto",
    fontWeight: "bold",
  },
  page: {
    width: "50%",
    height: "100%",
    padding: 10,
    fontFamily: "Roboto",
    fontSize: 11,
    position: "relative",
    backgroundColor: "#fff",
    flexDirection: "column",
  },
  mainContent: {
    zIndex: 2,
    marginTop: 20,
    flexGrow: 1,
  },
  logo: {
    position: "absolute",
    top: 30,
    left: 30,
    width: 150,
  },
  logo2: {
    position: "absolute",
    top: 30,
    left: 30,
    width: 60,
  },
  upperDesign: {
    position: "absolute",
    top: -10,
    right: 0,
    width: 280,
  },
  lowerDesign: {
    position: "absolute",
    bottom: -10,
    right: 0,
    width: 300,
  },
  navigation: {
    position: "absolute",
    top: 40,
    right: 0,
    width: 450,
  },
  pageNumber_Box: {
    position: "absolute",
    bottom: 20,
    left: 10,
    width: 25,
    height: 25,
    border: "2px solid orange",
    borderRadius: 15,
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    zIndex: 2,
  },
  pageNumber: {
    fontSize: 11,
    color: "#000",
    textAlign: "center",
  },
});
const WrapperPage = ({
  children,
  showLogo = false,
  showLogo2 = false,
  showUpper = false,
  showLower = false,
  showNavigation = false,
  showFooterText = false,
  showPageNumber = false,
  assets,
}) => (
  <Page size="A4" style={styles.page}>
    {showUpper && <Image src={assets.upper} style={styles.upperDesign} />}
    {showLower && <Image src={assets.lower} style={styles.lowerDesign} />}
    {showNavigation && (
      <Image src={assets.navigation} style={styles.navigation} />
    )}
    {showLogo && <Image src={assets.logo} style={styles.logo} />}
    {showLogo2 && <Image src={assets.logo2} style={styles.logo2} />}
    <View style={styles.mainContent}>{children}</View>
    {/* Footer: page number only (website/email text removed); showFooterText gates this area */}
    {(showFooterText || showPageNumber) && (
      <>
        {showPageNumber && (
          <View style={styles.pageNumber_Box} fixed>
            <Text
              style={styles.pageNumber}
              render={({ pageNumber, totalPages }) => `${pageNumber}`}
              fixed
            />
          </View>
        )}
      </>
    )}
  </Page>
);

export default WrapperPage;
